// sessionTimeoutMiddleware.ts
import { Middleware } from "redux";
import { resetSessionTimer, setActivityStatus } from "../slices/userSlice";

const SESSION_TIMEOUT_MS =
  parseFloat(process.env.REACT_APP_SESSION_TIMEOUT_MINS ?? "30") * 60 * 1000; // default 30 minutes

const NOTIFICATION_TIMEOUT_MS =
  SESSION_TIMEOUT_MS -
  parseFloat(process.env.REACT_APP_SESSION_WARNING_MINS ?? "5") * 60 * 1000; // deafult 5 minutes


let sessionTimeoutTimer: ReturnType<typeof setTimeout> | null = null;
let notificationTimer: ReturnType<typeof setTimeout> | null = null;

export const sessionTimeoutMiddleware: Middleware =
  (store) => (next) => (action: any) => {
    if (action?.type === resetSessionTimer.type) {
      store.dispatch(setActivityStatus("online"));

      if (notificationTimer) clearTimeout(notificationTimer);
      notificationTimer = setTimeout(async () => {
        store.dispatch(setActivityStatus("idle"));
      }, NOTIFICATION_TIMEOUT_MS);

      if (sessionTimeoutTimer) clearTimeout(sessionTimeoutTimer);
      sessionTimeoutTimer = setTimeout(async () => {
        store.dispatch(setActivityStatus("offline"));
      }, SESSION_TIMEOUT_MS);
    }
    return next(action);
  };
